import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import * as AMap from '../../../../../common/amap';
import ReactSwipe from 'react-swipe';
import './index.less';

const PageModel = props => {
    let reactSwipeEl;
    const [url, setUrl] = useState('');
    const [menus, setMenus] = useState([]);
    const [items, setItems] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [list, setList] = useState([]);
    const [shopFlag, setShopFlag] = useState(false);
    const [shopModalObj, setShopModalObj] = useState({});
    const [shopCoverIndex, setShopCoverIndex] = useState(0);

    // 状态管理
    const [selectedPrimary, setSelectedPrimary] = useState(null);
    const [selectedSecondary, setSelectedSecondary] = useState(null);

    //一级菜单选中
    const toggleMenu = (index) => {
        setItems(menus[index].children);
        setSelectedPrimary(menus[index].id);
        setSelectedSecondary(null);
        getSelectList({ 'onetype': menus[index].id });
    };

    const getbanner = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 5 }
        });
        if (!result) return;
        setUrl(result.data.link);
    };

    const getActivityList = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/h5activity/list',
        });
        if (!result) return;
        setActivityList(result.data);
    }
    const getTypesList = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/types/list',
        });
        if (!result) return;
        const categorizedData = categorizeData(result.data);
        setMenus(categorizedData)
        // setItems(categorizedData[0].children);

        //获取商户列表 
        // getSelectList({ 'onetype': categorizedData[0].id });
    }
    function categorizeData(data) {
        const topLevel = data.filter(item => item.pid === 0);
        const result = topLevel.map(parent => {
            const children = data.filter(item => item.pid === parent.id)
                .map(child => ({
                    id: child.id,
                    name: child.pname
                }));
            return {
                id: parent.id,
                name: parent.pname,
                children: children.length > 0 ? children : null
            };
        });

        return result;
    }
    const getSelectList = async (data = {}) => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/select/list',
            data
        });
        if (!result) return;
        setList(result.data);
    }
    const getAllSel = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/select/alllist',
            data: { 'isSel': 1 }
        });
        if (!result) return;
        setList(result.data);
    }
    useEffect(() => {
        getbanner();//获取头部的banner图
        getActivityList();//获取精彩活动列表
        getTypesList();//获取分类类目列表

        getAllSel();//默认进来获取手动精选的店铺
        Utils.setPageTitle('古镇精选');
        return () => false;
    }, [123]);


    return (
        <section className="h5activity-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5activity-top-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url} alt="" />
            </div>
            <div className='h5activity-top'>
                {
                    [1].map((item, index) => {
                        return (
                            <div className='h5activity-top-item' key={index}>
                                <div className='h5activity-top-item-title'>精彩活动</div>
                                <div className='h5activity-top-item-content'>参与丰富多彩的现场体验</div>
                                <div className='h5activity-top-item-list'>
                                    {activityList.map((item2, index2) => {
                                        return (
                                            <div className='h5activity-top-item-list-item' key={index2} onClick={() => {
                                                if (item2.type == 1 && item2.link) {
                                                    window.location.href = item2.link;
                                                } else if (item2.type == 2) {
                                                    props.history.push(`/zhujiajiao/h5activity/${item2.id}`);
                                                }
                                            }}>
                                                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + item2.cover} alt="" ></img>
                                                <div className='h5activity-top-item-list-item-title'>{item2.title}</div>
                                            </div>
                                        )
                                    })
                                    }
                                </div>
                            </div>
                        )
                    })
                }

                <div className='h5activity-top-item'>
                    <div className='h5activity-top-item-title'>商铺推荐</div>
                    <div className='h5activity-top-item-content'>发现角里特色与优质商品</div>
                    <div className="menu-container">
                        {menus.map((menu, index) => (
                            <div key={index} className="menu-section">
                                <div 
                                    className={`menu-title ${selectedPrimary === menu.id ? 'active' : ''}`}
                                    onClick={() => toggleMenu(index)}>{menu.name}</div>
                            </div>
                        ))}
                    </div>
                    {
                        <div className="menu-items">
                            {items && items.length > 0 && items.map((item, itemIndex) => (
                                <div key={itemIndex} className={`menu-item ${selectedSecondary === item.id ? 'actives' : ''}`} onClick={() => {
                                    setSelectedSecondary(item.id)
                                    getSelectList({ twotype: item.id });
                                }
                                }>
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    }

                    <div className='h5activity-top-item-lists'>
                        {
                            list.length > 0 && list.map((item, index) => {
                                return (
                                    <div className='h5activity-top-item-list-items' key={index} onClick={() => {
                                        setShopFlag(true);
                                        setShopModalObj(item);
                                        setShopCoverIndex(0);
                                    }}>
                                        <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + item.cover} alt="" ></img>
                                        <div className='h5activity-top-item-list-items-title'>
                                            <div className='name'>{item.company}</div>
                                            <div className='address'>
                                                <div className='address-left'>
                                                    <div className='address-left-item'>{item.address}</div>
                                                    <div className='address-left-item'>电话：{item.tel}</div>
                                                </div>
                                                <div className='address-right' onClick={async () => {}}>
                                                    <img src={require('./images/daohang4.png')}></img>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>
            </div>

            <div className='h5activity-bottom-img'>
                <img src={require('./images/bottom.png')} alt="" />
            </div>

            {
                shopFlag && <>
                    <div className="shop-modal-bg" onClick={() => {
                        setShopFlag(false);
                    }} />
                    <div className="shop-modal-container">
                        <div style={{ position: 'relative' }}>
                            <ReactSwipe
                                className="shop-covers"
                                swipeOptions={{
                                    continuous: false,
                                    stopPropagation: false,
                                    transitionEnd: setShopCoverIndex
                                }}
                                ref={el => (reactSwipeEl = el)}
                            >
                                {
                                    shopModalObj?.img?.length > 0 && shopModalObj.img.split(',').map((pic, idx) => <div className="shop-cover-item" key={idx} style={{ backgroundImage: `url(${'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + pic})` }} />)
                                }
                            </ReactSwipe>
                            {
                                shopModalObj?.img?.length > 1 && <div className="shop-item-dot">
                                    {
                                        shopModalObj.img.split(',').map((citem, cidx) => <em className={cidx == shopCoverIndex ? 'active' : ''} key={cidx} />)
                                    }
                                </div>
                            }
                        </div>
                        <div className="shop-modal-content">
                            <div className="content-item">
                                <span className="title">{shopModalObj.company}</span>
                            </div>
                            <div className="content-item">
                                {shopModalObj.hours && <span>营业时间：{shopModalObj.hours}</span>}
                            </div>
                            <div className="content-item" onClick={async () => {
                                const res = await AMap.getCurrentPosition2();
                                let startAddress = '';
                                let startLngLat = '';
                                if (res.formattedAddress && res.lnglat) {
                                    startAddress = res.formattedAddress;
                                    startLngLat = res.lnglat.join(',');
                                }
                                let lng = shopModalObj.lng + ',' + shopModalObj.lat;//'121.050575,31.114525'
                                const link = `https://gaode.com/dir?from[name]=${startAddress}&from[lnglat]=${startLngLat}&to[name]=上海市${shopModalObj.address}&to[lnglat]=${lng}&policy=1&type=walk`;
                                window.location.href = link;
                                return;
                            }}>
                                {shopModalObj.address && <span>地址：{shopModalObj.address}</span>}
                                <img src={require('./images/daohang4.png')}></img>
                            </div>
                            <div className="content-item"  onClick={()=>{
                                setTimeout(function () {
                                    window.open(`${'tel:' + shopModalObj.tel +''}`);
                                }, 100);
                            }}>
                                {shopModalObj.tel && <span>电话：{shopModalObj.tel}</span>}
                                <img src={require('./images/bodadianhua.png')}></img>
                            </div>
                            {
                                shopModalObj.content &&
                                <div className="content-item-desc">
                                    {shopModalObj.content}
                                </div>
                            }
                        </div>
                    </div>
                </>
            }

        </section>
    );
};

export default PageModel;
